"use client";

import { c as _c } from "react/compiler-runtime";
import { Image } from "@opensea/next-ui-kit";
import { classNames, FlexCenter, FlexColumn, Spinner, TextBody, TextHeading, useToasts } from "@opensea/ui-kit";
import { Upload } from "@opensea/ui-kit/icons";
import { useTranslations } from "next-intl";
import ReactHlsPlayer from "react-hls-video-player";
import { useShallow } from "zustand/react/shallow";
import { useOverviewPreviewStore } from "@/components/collection/overview/components/OverviewPreviewProvider/OverviewPreviewProvider";
import { MediaUpload, useMediaUpload } from "@/components/studio/MediaUpload";
import { formatFileSize } from "@/lib/upload";
function PreviewImageContent(t0) {
  const $ = _c(18);
  const {
    selectedImageIndex
  } = t0;
  const {
    isUploading,
    url,
    file
  } = useMediaUpload();
  const t = useTranslations("PreviewImageMediaUpload");
  let t1;
  if ($[0] !== selectedImageIndex) {
    t1 = state => state.previewImages[selectedImageIndex];
    $[0] = selectedImageIndex;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const selectedPreviewMedia = useOverviewPreviewStore(useShallow(t1));
  let t2;
  if ($[2] !== selectedPreviewMedia) {
    t2 = function renderMediaContent() {
      if (!selectedPreviewMedia) {
        return null;
      }
      if (selectedPreviewMedia.mediaType === "IMAGE" || selectedPreviewMedia.__typename === "ImageMedia") {
        return <Image className="absolute z-1 size-full object-contain" height={600} src={selectedPreviewMedia.imageUrl || selectedPreviewMedia.url || ""} width={600} />;
      }
      if (selectedPreviewMedia.mediaType === "MUX_VIDEO" || selectedPreviewMedia.__typename === "MuxVideoMedia") {
        return <ReactHlsPlayer autoPlay={true} className="size-full object-cover object-center" controls={false} loop={true} muted={true} playsInline={true} src={`https://stream.mux.com/${selectedPreviewMedia.muxPlaybackId}.m3u8`} />;
      }
      if (selectedPreviewMedia.mediaType === "VIDEO" || selectedPreviewMedia.__typename === "VideoMedia") {
        return <video autoPlay={true} className="absolute z-1 size-full object-contain" controls={true} loop={true} muted={true} playsInline={true} src={selectedPreviewMedia.videoUrl || selectedPreviewMedia.url || ""} />;
      }
    };
    $[2] = selectedPreviewMedia;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const renderMediaContent = t2;
  let t3;
  if ($[4] !== renderMediaContent) {
    t3 = renderMediaContent();
    $[4] = renderMediaContent;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = url ? "opacity-0" : "opacity-100";
  let t5;
  if ($[6] !== t4) {
    t5 = classNames("animate-opacity items-center duration-200", t4);
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== file || $[9] !== isUploading || $[10] !== t) {
    t6 = isUploading ? <><FlexCenter className="rounded-sm bg-success-1-transparent-1 px-3 py-1.5"><Spinner className="border-success-1" size="xs" /><TextBody className="ml-2 font-mono uppercase" color="success-1">{t("uploading")}</TextBody></FlexCenter>{file ? <TextHeading className="my-3" size="sm">{file.name}</TextHeading> : null}{file ? <TextBody className="font-mono uppercase" color="text-secondary">{formatFileSize(file.size)}</TextBody> : null}</> : <><FlexCenter className="rounded-sm bg-bg-additional-2 p-2"><Upload size={16} /></FlexCenter><TextBody className="my-4" size="md" weight="semibold">{t("clickHereToUpload")}</TextBody><TextBody className="font-mono uppercase" color="text-secondary">{t("maxSize", {
          size: "100"
        })}</TextBody></>;
    $[8] = file;
    $[9] = isUploading;
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <FlexColumn className={t5}>{t6}</FlexColumn>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t3 || $[16] !== t7) {
    t8 = <FlexColumn className="relative aspect-1/1 w-full items-center justify-center overflow-hidden rounded-lg border border-border-1 border-dashed bg-bg-primary-transparent object-contain">{t3}{t7}</FlexColumn>;
    $[15] = t3;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
}
export function PreviewImageMediaUpload(t0) {
  const $ = _c(14);
  const {
    selectedImageIndex,
    onSuccess
  } = t0;
  const {
    showErrorMessage
  } = useToasts();
  const slug = useOverviewPreviewStore(_temp);
  const t = useTranslations("PreviewImageMediaUpload");
  let t1;
  if ($[0] !== showErrorMessage || $[1] !== t) {
    t1 = () => {
      showErrorMessage(t("uploadFailed"));
    };
    $[0] = showErrorMessage;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== onSuccess) {
    t2 = t3 => {
      const {
        file,
        token,
        url
      } = t3;
      const previewImageData = {
        token,
        url,
        mediaType: file.type.startsWith("video/") ? "VIDEO" : "IMAGE"
      };
      onSuccess(previewImageData);
    };
    $[3] = onSuccess;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = ["jpg", "png", "gif", "webp", "mp4"];
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== selectedImageIndex) {
    t4 = <PreviewImageContent selectedImageIndex={selectedImageIndex} />;
    $[6] = selectedImageIndex;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== selectedImageIndex || $[9] !== slug || $[10] !== t1 || $[11] !== t2 || $[12] !== t4) {
    t5 = <MediaUpload key={selectedImageIndex} onError={t1} onSuccess={t2} section="ABOUT" slug={slug} supportedFileTypes={t3} uploadAttribute="PREVIEW_MEDIA">{t4}</MediaUpload>;
    $[8] = selectedImageIndex;
    $[9] = slug;
    $[10] = t1;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}
function _temp(state) {
  return state.slug;
}